export class Navbar {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( window ).on( 'scroll load', () => {
            let scroll = $( window ).scrollTop();

            if ( scroll > 49 ) {
                $( '#page-header' ).addClass( 'active' );
            } else {
                $( '#page-header' ).removeClass( 'active' );
            }

            if ( scroll > 200 ) {
                $( '#scrollTop' ).addClass( 'active' );
            } else {
                $( '#scrollTop' ).removeClass( 'active' );
            }
        } );

        $( window ).on( 'load resize', () => {
            this.calculateNavigation( window.outerWidth );
        } );

        $( '#scrollTop' ).on( 'click', function( e ) {
            e.preventDefault();
            $( 'html, body' ).animate( { scrollTop: 0 }, 1000 );
        } );

        $( '#index .navbar-brand' ).on( 'click', function( e ) {
            e.preventDefault();
            $( 'html, body' ).animate( { scrollTop: 0 }, 1000 );
        } );

        $( '.link-scroll' ).on( 'click', function( e ) {
            if ( $( '.navbar-collapse' ).hasClass( 'show' ) ) {
                setTimeout( () => {
                    $( '.navbar-toggler' ).click();
                    $( '.navbar-check' ).prop( 'checked', false );
                }, 500 );
            }
            var anchor = $( this );
            $( 'html, body' ).stop().animate( {
                scrollTop: $( anchor.attr( 'href' ) ).offset().top - $( '#page-header' ).height() - 50
            }, 1000 );

            e.preventDefault();
        } );

        $( 'ul.dropdown-menu [data-toggle=\'dropdown\']' ).on( 'click', function( event ) {
            event.preventDefault();
            event.stopPropagation();

            $( this ).siblings().toggleClass( 'show' );

            if ( !$( this ).next().hasClass( 'show' ) ) {
                $( this ).parents( '.dropdown-menu' ).first().find( '.show' ).removeClass( 'show' );
            }
            $( this ).parents( 'li.nav-item.dropdown.show' ).on( 'hidden.bs.dropdown', function( e ) {
                $( '.dropdown-submenu .show' ).removeClass( 'show' );
            } );

        } );

        if ( window.location.search && window.location.search.indexOf( '?u=' ) !== - 1 ) {
            let service = window.location.search.slice( 3 );
            $( 'html, body' ).stop().animate( {
                scrollTop: $( '#' + service ).offset().top - $( '#page-header' ).height() - 50
            }, 1000 );
        }

    }

    calculateNavigation( size = 0 ) {
        const navigation = $( '#page-header .navbar-nav' );
        const navigationItems = $( '#page-header .navbar-nav > .nav-item' );
        const collapseNavigation = $( '#page-header .collapse-navigation' );
        const collapseNavigationItems = $( '#page-header .collapse-navigation .nav-item' );

        if ( collapseNavigation && collapseNavigationItems && collapseNavigationItems.length > 0 ) {
            collapseNavigation.hide();
            let i = 0;
            for ( let item of navigationItems ) {
                if ( !item || !collapseNavigationItems[ i ] ) {
                    return;
                }
                item.className = 'nav-item d-block';
                collapseNavigationItems[ i ].className = 'nav-item d-none';
                i ++;
            }
        }

        if ( size < 991 ) {
            return;
        }

        const navigationWidth = navigation?.[ 0 ]?.offsetWidth - 50;

        if ( navigationItems && navigationItems.length > 0 ) {
            let navigationItemsWidth = 0;
            let i = 0;
            for ( let item of navigationItems ) {
                navigationItemsWidth = navigationItemsWidth + item.offsetWidth;
                if ( navigationItemsWidth >= navigationWidth ) {
                    collapseNavigation.show();
                    item.className = 'nav-item d-none';
                    collapseNavigationItems[ i ].className = 'nav-item d-block';
                }

                i ++;
            }

            //console.log( navigationItemsWidth );
        }
    }
}
